import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { jakusci, left_arrow, master_img, pool, right_arrow, tub } from "../../assets/imgs";
import { Amenities_list } from "../../screens/redux/api/dummyJson";
import CustomerOptionsAdd from "./CustomerOptionsAdd";
import DescriptionAdd from "./DescriptionAdd";
import CancelIcon from "@mui/icons-material/Cancel";
import Select from "react-select";
import SelectBox from "../SelectBox";
import { useAmenitiesListMutation, useLazyPropertyAmenitiesListQuery, usePropertyDetailsAddMutation, usePropertyRoomDetailsAddMutation } from "../../screens/redux/api/api";
import { toast } from "react-toastify";
import moment from "moment";

const PropertyDetailsAdd = ({ setValueType, valueType, setTabs, property_id, owner_id }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [validation, setValidation] = useState('')
  const [users, setUsers] = useState([])
  const [selected, setSelected] = useState([])


  console.log('proprty_id', property_id)

  // Centralized state for all form data
  const [formData, setFormData] = useState({
    // Availability
    availability: [{ key: "", value: "" }],

    // Amenities
    amenityIds: [],
    amenityNames: [],

    // Customer Options
    check_in: "",
    check_out: "",
    description: "",
    country_id: null,
    state_id: null,
    city_id: null,
    area_id: null,
    address: "",
    age_category_id: null,
    is_couple_friendly: 1,
    is_local_id_allowed: 0,
    latitude: "",
    longitude: "",
    total_person_count: "",
    extra_person_count: "",
    extra_charges_per_person: "",
    pricing: {
      mon_price: "",
      tue_price: "",
      wed_price: "",
      thu_price: "",
      fri_price: "",
      sat_price: "",
      sun_price: ""
    },

    // Description
    cancellation_policy: "",
    house_rules: "",
    safety_property: "",
    additional_details: [{ title: "", value: "" }],
    property_images: []
  });



  // RTK Query
  const [propertyDetailAddApi] = usePropertyDetailsAddMutation();
  const [aminitiesListApi] = useLazyPropertyAmenitiesListQuery()



  const getList = () => {
    let formdata = new FormData()
    formdata.append('pagination', 0)
    aminitiesListApi(formdata)
      .unwrap()
      .then((res) => {
        console.log('res-ami', res)
        setUsers(res?.amenities)
      }).catch((err) => {
        console.error('err-ami', err)
      })
  }


  useEffect(() => {
    getList()
  }, [])



  const handleSubmit = async () => {

    const invalidAvailability = formData.availability.some(
      (item) => !item.key || item.key.trim() === "" || item.value === null || item.value === ""
    );

    if (invalidAvailability) {
      toast.error("Availability fields must have both a key and a value.");
      return;
    }

    if (!formData.amenityNames || formData.amenityNames.length === 0) {
      toast.error("Please select at least one amenity.");
      return;
    }

    if (!formData.check_in) {
      toast.error("Check-in time is required.");
      return;
    }

    if (!formData.check_out) {
      toast.error("Check-out time is required.");
      return;
    }

    if (valueType !== 2) {
      const missingPriceDay = Object.entries(formData.pricing).find(
        ([key, value]) =>
          ["mon_price", "tue_price", "wed_price", "thu_price", "fri_price", "sat_price", "sun_price"].includes(key) &&
          (value === undefined || value === null || value === "")
      );
      if (missingPriceDay) {
        toast.error(`Price for ${missingPriceDay[0].replace("_price", "").toUpperCase()} is required.`);
        return;
      }
    }

    // If not valueType 2, validate pricing
    if (valueType !== 2) {
      if (!formData.total_person_count) {
        toast.error("Total persons count is required.");
        return;
      }
      if (!formData.extra_person_count) {
        toast.error("Additional persons count is required.");
        return;
      }
      if (!formData.extra_charges_per_person) {
        toast.error("Extra charge per person is required.");
        return;
      }
    }
    if (!formData.age_category_id) {
      toast.error("Age category is required.");
      return;
    }
    if (!formData.country_id) {
      toast.error("Country is required.");
      return;
    }

    if (!formData.state_id) {
      toast.error("State is required.");
      return;
    }

    if (!formData.city_id) {
      toast.error("City is required.");
      return;
    }

    if (!formData.area_id) {
      toast.error("Area is required.");
      return;
    }
    if (!formData.latitude || !formData.longitude) {
      toast.error("Latitude and Longitude are required.");
      return;
    }
    if (!formData.address) {
      toast.error("Address is required.");
      return;
    }
    if (!formData.description) {
      toast.error("Description is required.");
      return;
    }


    if (formData.is_couple_friendly === null || formData.is_couple_friendly === undefined) {
      toast.error("Please select if the property is couple friendly.");
      return;
    }

    if (formData.is_local_id_allowed === null || formData.is_local_id_allowed === undefined) {
      toast.error("Please select if local ID is allowed.");
      return;
    }


    // Validate policies
    if (!formData.cancellation_policy) {
      toast.error("Cancellation policy is required.");
      return;
    }

    if (!formData.house_rules) {
      toast.error("House rules are required.");
      return;
    }

    if (!formData.safety_property) {
      toast.error("Safety & property policy is required.");
      return;
    }

    // // Validate additional details
    // const invalidAdditionalDetail = formData.additional_details?.find(item => !item.title || !item.value);
    // if (invalidAdditionalDetail) {
    //   toast.error("All additional policy titles and values must be filled.");
    //   return;
    // }

    // Validate images
    if (!formData.property_images || formData.property_images.length === 0) {
      toast.error("At least one property image is required.");
      return;
    }

    setLoading(true);

    try {
      // 1. Convert availability array to object format
      const availabilitiesObj = {};
      formData.availability.forEach((item) => {
        if (item.key && item.value) {
          availabilitiesObj[item.key] = item.value;
        }
      });
      // 1. Convert availability array to object format
      // const availabilitiesObj = {};
      // formData.availability.forEach(([key, value]) => {
      //   if (key.trim() && value.trim()) {
      //     // Only add if both key and value are non-empty
      //     availabilitiesObj[key] = value;
      //   }
      // });

      // 2. Prepare FormData
      const formDataToSend = new FormData();
      formDataToSend.append('property_id', property_id);

      // 3. Append amenities
      formData.amenityNames.forEach((item, index) => {
        formDataToSend.append(`amenity_ids[${index}]`, item?.id);
      });

      // 4. Append availabilities
      formDataToSend.append('availabilities', JSON.stringify(availabilitiesObj));

      // 5. Handle time fields
      if (formData.check_in) {
        const formattedCheckIn = moment(formData.check_in, 'HH:mm').format('HH:mm');
        formDataToSend.append('check_in', formattedCheckIn);
      }

      if (formData.check_out) {
        const formattedCheckOut = moment(formData.check_out, 'HH:mm').format('HH:mm');
        formDataToSend.append('check_out', formattedCheckOut);
      }

      // 6. Append other customer option data
      const customerOptions = {
        description: formData.description,
        country_id: formData.country_id,
        state_id: formData.state_id,
        city_id: formData.city_id,
        area_id: formData.area_id,
        address: formData.address,
        age_category_id: formData.age_category_id,
        is_couple_friendly: formData.is_couple_friendly,
        is_local_id_allowed: formData.is_local_id_allowed,
        latitude: formData.latitude,
        longitude: formData.longitude,
        // total_persons: formData.total_person_count,
        // additional_persons: formData.extra_person_count,
        // extra_charge_per_person: formData.extra_charges_per_person
      };



      if (valueType != 2) {
        customerOptions.pricing = {
          ...formData.pricing,
          total_persons: formData.total_person_count,
          additional_persons: formData.extra_person_count,
          extra_charge_per_person: formData.extra_charges_per_person,
        };
      }

      Object.entries(customerOptions).forEach(([key, value]) => {
        console.log("keyvalue", key, value);

        if (value !== undefined && value !== null) {
          if (key === 'pricing' && typeof value === 'object') {
            Object.entries(value).forEach(([pricingKey, pricingValue]) => {
              formDataToSend.append(`pricing[${pricingKey}]`, pricingValue);

            });
          } else {
            formDataToSend.append(key, value);
          }
        }
      });

      // 7. Append description data
      // Property policies
      const policies = [
        {
          policy_id: 1,
          policy_name: "Cancellation Policy", // Add policy_name
          description: formData.cancellation_policy
        },
        {
          policy_id: 2,
          policy_name: "House Rules", // Add policy_name
          description: formData.house_rules
        },
        {
          policy_id: 3,
          policy_name: "Safety & Property", // Add policy_name
          description: formData.safety_property
        },
        ...formData.additional_details
          .filter(item => item.title && item.value)
          .map((item, index) => ({
            policy_id: index + 4,
            policy_name: item.title,
            description: item.value
          }))
      ].filter(policy => policy.description);

      policies.forEach((policy, index) => {
        // formDataToSend.append(`property_policies[${index}][policy_id]`, policy.policy_id);
        formDataToSend.append(`property_policies[${index}][policy_name]`, policy.policy_name || '');
        formDataToSend.append(`property_policies[${index}][description]`, policy.description);
      });
      // Property images - append as binary files
      formData.property_images.forEach((image, index) => {
        console.log("images", image.file)
        formDataToSend.append(`property_images[${index}][image]`, image.file);
        formDataToSend.append(`property_images[${index}][position]`, index + 1);
      });

      // 8. Make API call
      const res = await propertyDetailAddApi(formDataToSend).unwrap();

      if (res?.status === 'success') {
        toast.success(res?.message);
        // navigate("/property");
        navigate("/property-approve-view", {
          state: {
            tab: 6,
            owner_id: owner_id,
            property_id: property_id,
          }
        })
      } else {
        console.warn('API returned non-success status:', res);
      }

    } catch (err) {
      console.error("API Error:", err);
      toast.error(err?.data?.message || "Failed to submit property details");
    } finally {
      setLoading(false);
    }
  };

  const handleRoomSubmit = async () => {

    const invalidAvailability = formData.availability.some(
      (item) => !item.key || item.key.trim() === "" || item.value === null || item.value === ""
    );
    if (invalidAvailability) {
      toast.error("Availability fields must have both a key and a value.");
      return;
    }


    if (!formData.amenityNames || formData.amenityNames.length === 0) {
      toast.error("Please select at least one amenity.");
      return;
    }

    if (!formData.check_in) {
      toast.error("Check-in time is required.");
      return;
    }

    if (!formData.check_out) {
      toast.error("Check-out time is required.");
      return;
    }

    if (valueType !== 2) {
      const missingPriceDay = Object.entries(formData.pricing).find(
        ([key, value]) =>
          ["mon_price", "tue_price", "wed_price", "thu_price", "fri_price", "sat_price", "sun_price"].includes(key) &&
          (value === undefined || value === null || value === "")
      );
      if (missingPriceDay) {
        toast.error(`Price for ${missingPriceDay[0].replace("_price", "").toUpperCase()} is required.`);
        return;
      }
    }

    // If not valueType 2, validate pricing
    if (valueType !== 2) {
      if (!formData.total_person_count) {
        toast.error("Total persons count is required.");
        return;
      }
      if (!formData.extra_person_count) {
        toast.error("Additional persons count is required.");
        return;
      }
      if (!formData.extra_charges_per_person) {
        toast.error("Extra charge per person is required.");
        return;
      }
    }
    if (!formData.age_category_id) {
      toast.error("Age category is required.");
      return;
    }
    if (!formData.country_id) {
      toast.error("Country is required.");
      return;
    }

    if (!formData.state_id) {
      toast.error("State is required.");
      return;
    }

    if (!formData.city_id) {
      toast.error("City is required.");
      return;
    }

    if (!formData.area_id) {
      toast.error("Area is required.");
      return;
    }
    if (!formData.latitude || !formData.longitude) {
      toast.error("Latitude and Longitude are required.");
      return;
    }
    if (!formData.address) {
      toast.error("Address is required.");
      return;
    }
    if (!formData.description) {
      toast.error("Description is required.");
      return;
    }


    if (formData.is_couple_friendly === null || formData.is_couple_friendly === undefined) {
      toast.error("Please select if the property is couple friendly.");
      return;
    }

    if (formData.is_local_id_allowed === null || formData.is_local_id_allowed === undefined) {
      toast.error("Please select if local ID is allowed.");
      return;
    }





    // Validate policies
    if (!formData.cancellation_policy) {
      toast.error("Cancellation policy is required.");
      return;
    }

    if (!formData.house_rules) {
      toast.error("House rules are required.");
      return;
    }

    if (!formData.safety_property) {
      toast.error("Safety & property policy is required.");
      return;
    }

    // // Validate additional details
    // const invalidAdditionalDetail = formData.additional_details?.find(item => !item.title || !item.value);
    // if (invalidAdditionalDetail) {
    //   toast.error("All additional policy titles and values must be filled.");
    //   return;
    // }

    // Validate images
    if (!formData.property_images || formData.property_images.length === 0) {
      toast.error("At least one property image is required.");
      return;
    }



    setLoading(true);

    try {
      // 1. Convert availability array to object format
      const availabilitiesObj = {};
      formData.availability.forEach((item) => {
        if (item.key && item.value) {
          availabilitiesObj[item.key] = item.value;
        }
      });
      //  const availabilitiesObj = {};
      // formData.availability.forEach(([key, value]) => {
      //   if (key.trim() && value.trim()) {
      //     // Only add if both key and value are non-empty
      //     availabilitiesObj[key] = value;
      //   }
      // });

      // 2. Prepare FormData
      const formDataToSend = new FormData();
      formDataToSend.append('property_id', property_id);

      // 3. Append amenities
      formData.amenityNames.forEach((item, index) => {
        formDataToSend.append(`amenity_ids[${index}]`, item?.id);
      });

      // 4. Append availabilities
      formDataToSend.append('availabilities', JSON.stringify(availabilitiesObj));

      // 5. Handle time fields
      if (formData.check_in) {
        const formattedCheckIn = moment(formData.check_in, 'HH:mm').format('HH:mm');
        formDataToSend.append('check_in', formattedCheckIn);
      }

      if (formData.check_out) {
        const formattedCheckOut = moment(formData.check_out, 'HH:mm').format('HH:mm');
        formDataToSend.append('check_out', formattedCheckOut);
      }

      // 6. Append other customer option data
      const customerOptions = {
        description: formData.description,
        country_id: formData.country_id,
        state_id: formData.state_id,
        city_id: formData.city_id,
        area_id: formData.area_id,
        address: formData.address,
        age_category_id: formData.age_category_id,
        is_couple_friendly: formData.is_couple_friendly,
        is_local_id_allowed: formData.is_local_id_allowed,
        latitude: formData.latitude,
        longitude: formData.longitude,
        // total_persons: formData.total_person_count,
        // additional_persons: formData.extra_person_count,
        // extra_charge_per_person: formData.extra_charges_per_person
      };

      if (valueType != 2) {
        customerOptions.pricing = {
          ...formData.pricing,
          total_persons: formData.total_person_count,
          additional_persons: formData.extra_person_count,
          extra_charge_per_person: formData.extra_charges_per_person,
        };
      }

      Object.entries(customerOptions).forEach(([key, value]) => {
        console.log("jey", key, value)
        if (value !== undefined && value !== null) {
          if (key === 'pricing' && typeof value === 'object') {
            Object.entries(value).forEach(([pricingKey, pricingValue]) => {
              formDataToSend.append(`pricing[${pricingKey}]`, pricingValue);

            });
          } else {
            formDataToSend.append(key, value);
          }
        }
      });

      // 7. Append description data
      // Property policies
      const policies = [
        {
          policy_id: 1,
          policy_name: "Cancellation Policy", // Add policy_name
          description: formData.cancellation_policy
        },
        {
          policy_id: 2,
          policy_name: "House Rules", // Add policy_name
          description: formData.house_rules
        },
        {
          policy_id: 3,
          policy_name: "Safety & Property", // Add policy_name
          description: formData.safety_property
        },
        ...formData.additional_details
          .filter(item => item.title && item.value)
          .map((item, index) => ({
            policy_id: index + 4,
            policy_name: item.title,
            description: item.value
          }))
      ].filter(policy => policy.description);

      policies.forEach((policy, index) => {
        // formDataToSend.append(`property_policies[${index}][policy_id]`, policy.policy_id);
        formDataToSend.append(`property_policies[${index}][policy_name]`, policy.policy_name || '');
        formDataToSend.append(`property_policies[${index}][description]`, policy.description);
      });
      // Property images - append as binary files
      formData.property_images.forEach((image, index) => {
        console.log("images", image.file)
        formDataToSend.append(`property_images[${index}][image]`, image.file);
        formDataToSend.append(`property_images[${index}][position]`, index + 1);
      });

      // 8. Make API call
      const res = await propertyDetailAddApi(formDataToSend).unwrap();

      if (res?.status === 'success') {
        toast.success(res?.message);
        setTabs(3)
      } else {
        console.warn('API returned non-success status:', res);
      }

    } catch (err) {
      console.error("API Error:", err);
      toast.error(err?.data?.message || "Failed to submit property details");
    } finally {
      setLoading(false);
    }
  };

  // Availability handlers
  const addAvailability = () => {
    setFormData(prev => ({
      ...prev,
      availability: [...prev.availability, { key: "", value: "" }]
    }));
  };

  const removeAvailability = (ind) => {
    setFormData(prev => ({
      ...prev,
      availability: prev.availability.filter((_, i) => i !== ind)
    }));
  };

  const handleAvailability = (event, type, ind) => {
    setFormData(prev => {
      const newAvailability = [...prev.availability];
      newAvailability[ind] = {
        ...newAvailability[ind],
        [type]: event
      };
      return { ...prev, availability: newAvailability };
    });
  };

  // Amenities handlers
  const removeAmenities = (ind, name) => {
    let temp = [...selected]
    let inx = temp.indexOf(name)
    temp.splice(inx, 1)
    setSelected(temp)
    setFormData(prev => ({
      ...prev,
      amenityNames: prev.amenityNames.filter((_, i) => i !== ind),
      amenityIds: prev.amenityIds.filter((_, i) => i !== ind)
    }));
  };


  const options = users.map((item) => ({
    value: item.name,
    label: item.name
  }));

  return (
    <div className=" mt-2">
      <div className="d-flex ac-js">
        <div className="d-flex ac-js pointer gap-2">
          <img
            src={left_arrow}
            className="leftArrow mb-3 pointer"
            onClick={() => setTabs(1)}
          />
          <p
            className="f2 fs-sm-10 fs-md-16 fs-lg-16 fs-xl-18 fs-xxl-20 primary pointer"
            onClick={() => setTabs(1)}
          >
            Back
          </p>
        </div>
      </div>

      <div className="">
        <div className="d-flex ac-js gap-3 mb-3">
          <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
            Availability
          </h4>
          {formData.availability.length < 4 && (<button
            className={"cust-btn recep-yes mt-3"}
            onClick={addAvailability}
          >
            Add
          </button>)}
        </div>
        <div className="mb-4">
          <div className="col-md-12">
            <div className="d-flex ac-jb flex-wrap gap-3 col-md-12">
              {formData.availability?.map((item, ind) => {
                return (
                  <div className="col-md-5 d-flex ac-jb" key={ind}>
                    <div className="w-40">
                      <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 primary1">
                        Key
                      </h4>
                      <input
                        type="text"
                        className="input-pop ps-2 w-100"
                        placeholder="Key"
                        value={item?.key}
                        onChange={(e) =>
                          handleAvailability(e.target.value, "key", ind)
                        }
                      />
                    </div>
                    <div className="w-40">
                      <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 primary1 d-flex ac-jb">
                        Value
                        {ind > 0 && (
                          <div onClick={() => removeAvailability(ind)}>
                            <CancelIcon className="text-danger" />
                          </div>
                        )}
                      </h4>
                      <input
                        type="number"
                        className="input-pop ps-2 w-100"
                        placeholder="Value"
                        value={item?.value}
                        onChange={(e) =>
                          handleAvailability(e.target.value, "value", ind)
                        }
                      />
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
          Amenities
        </h4>
        <div className="mt-3 mb-4 col-md-5">
          <SelectBox
            array_list={users}
            value_text={selected}
            setvalue_text={(names) => {
              setSelected(names)
              let selectedarr = []
              users?.map(item => {
                if (names.includes(item?.name)) {
                  selectedarr.push(item)
                }
              })
              setFormData(prev => ({ ...prev, amenityNames: selectedarr }))
            }}
            value_id={formData.amenityIds}
            setvalue_id={(ids) => setFormData(prev => ({ ...prev, amenityIds: ids }))}
            placeholder_text={"Select Amenities"}
            isMulti={true}
            isTextArea={false}
            setValidation={setValidation} // string
          />
        </div>
        <div className="d-flex ac-js gap-3">
          <div className="col-md-12">
            <div className="d-flex align-items-center  flex-wrap gap-4">
              {formData.amenityNames?.map((item, ind) => {
                return (
                  <div key={ind}>
                    <div className="d-flex ac-jc gap-1 p-2 input-pop mb-3 position-relative">
                      <img
                        src={
                          item?.image_url
                        }
                        alt=""
                        className="tub-img"
                      />
                      <p className="f1 fs-sm-10 fs-md-10 fs-lg-12 fs-xl-14 fs-xxl-16 mb-0 primary">
                        {item?.name}
                      </p>
                      <div onClick={() => removeAmenities(ind, item?.name)}>
                        <CancelIcon
                          className="red  pointer"
                          style={{
                            position: "absolute",
                            top: "-12px",
                            right: "-7px",
                            width: "15px",
                          }}
                        />
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>

      <CustomerOptionsAdd
        valueType={valueType}
        formData={formData}
        setFormData={setFormData}
      />

      <DescriptionAdd
        formData={formData}
        setFormData={setFormData}
      />

      {valueType == 2 ? (
        <div className="d-flex ac-je">
          <div className="d-flex ac-js pointer gap-2">
            <p
              className="f2 fs-sm-10 fs-md-16 fs-lg-16 fs-xl-18 fs-xxl-20 primary"
              onClick={() => handleRoomSubmit()}

            >
              {loading ? 'laoding...' : ' Next'}

            </p>
            <img
              src={right_arrow}
              className="leftArrow mb-3"
              onClick={() => handleRoomSubmit()}
            />
          </div>
        </div>
      ) : (
        <div className="d-flex ac-je mt-5">
          <button
            className="login-btn f2 fs-sm-10 fs-md-8 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3 "
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading ? "Submitting..." : "Submit"}
          </button>
        </div>
      )}
    </div>
  );
};

export default PropertyDetailsAdd;